import React from "react";
import BasicDataCollectionForm from "./basic-data-collection-form";
import AgematchForm from "./agematch-form";
import CoppaForm from "./coppa-form";
import PhoneMatchForm from "./phonematch-form";

const DataCollectionForm = ({
  title,
  subtitle,
  icon,
  componentKey,
  endpoint,
  config,
  buttonText,
  loadingText,
  reAttempts = 0,
  onApiResponse,
}) => {
  // Route to appropriate specialized component based on componentKey
  if (componentKey === "idmatch/coppa") {
    return (
      <CoppaForm
        title={title}
        subtitle={subtitle}
        icon={icon}
        componentKey={componentKey}
        endpoint={endpoint}
        config={config}
        buttonText={buttonText}
        reAttempts={reAttempts}
        onApiResponse={onApiResponse}
      />
    );
  }
  
  if (componentKey === "agematch/process") {
    return (
      <AgematchForm
        title={title}
        subtitle={subtitle}
        icon={icon}
        componentKey={componentKey}
        endpoint={endpoint}
        config={config}
        buttonText={buttonText}
        reAttempts={reAttempts}
        onApiResponse={onApiResponse}
      />
    );
  }

  if (componentKey === "phonematch") {
    return (
      <PhoneMatchForm
        title={title}
        subtitle={subtitle}
        icon={icon}
        componentKey={componentKey}
        endpoint={endpoint}
        config={config}
        buttonText={buttonText}
        reAttempts={reAttempts}
        onApiResponse={onApiResponse}
      />
    );
  }
  
  // Default to basic form for all other components
  return (
    <BasicDataCollectionForm
      title={title}
      subtitle={subtitle}
      icon={icon}
      componentKey={componentKey}
      endpoint={endpoint}
      config={config}
      buttonText={buttonText}
      loadingText={loadingText}
      reAttempts={reAttempts}
      onApiResponse={onApiResponse}
    />
  );
};

export default DataCollectionForm;
